import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {LogicCondition} from "../../../models/jsonlogic/logic-condition";
import {LogicGroup} from "../../../models/jsonlogic/logic-group";
import {LogicGroupType} from "../../../models/jsonlogic/logic-group-type";
import {Store} from "../../../services/store.service";
import {BaseError} from "../../pages/base-error";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";
import {ILogicGeneric} from "../../../models/jsonlogic/logic-generic";
import * as _ from "lodash";

@Component({
  selector: "query-builder",
  templateUrl: "./query-builder.html",
  styleUrls: ["./query-builder.scss"],
})
export class QueryBuilder extends BaseError implements OnInit, OnChanges {
  public groups: LogicGroup[];
  public copy: LogicGroup[];
  @Input() public jsonLogic: any;
  public changeCopy: boolean = true;
  public determinantCount: number = 0;
  @Output() public onChange = new EventEmitter();
  @Input() public jsonString: any;
  @Input() public readOnly: boolean = false;
  @Input() public easyToRead: boolean = false;
  @Input() public noneSelectedText = "All";
  @Input() public noneSelectedSubText = "Drag and drop here";
  @Input() public prefix: string;
  @Input() public determinantMapById: { [key: string]: string } = {};
  private _refreshGroups: () => void;

  constructor(toastr: ToastrService, public store: Store, private determinantService: DeterminantControllerService) {
    super(toastr);
    this._refreshGroups = _.debounce(this.initGroups.bind(this), 250);
  }

  public ngOnInit(): void {
    this.initGroups();
  }

  public cleanDeterminant(logicGroups: LogicCondition[] | LogicGroup[]) {
    const items: ILogicGeneric[] = [];
    for (const eachGroup of logicGroups) {
      // @ts-ignore
      if (typeof eachGroup !== "object" || !eachGroup || !eachGroup.type || eachGroup.type !== LogicGroupType.OR && eachGroup.type !== LogicGroupType.AND && !(eachGroup.id || eachGroup.determinantId)) {
        continue;
      }
      const item: ILogicGeneric = { type: eachGroup.type };
      // @ts-ignore
      if (eachGroup.determinantId) {
        // @ts-ignore
        item.determinantId = eachGroup.determinantId;
        // @ts-ignore
        if (!this.determinantMapById[eachGroup.determinantId] && Array.isArray(eachGroup.items)) {
          const subItems = this.cleanDeterminant(eachGroup.items);
          if (subItems.length === 1 && subItems[0].determinantId && this.determinantMapById[subItems[0].determinantId]) {
            item.determinantId = subItems[0].determinantId;
          }
        }
        // @ts-ignore
      } else if (eachGroup.id) {
        // @ts-ignore
        if (this.determinantMapById[eachGroup.id]) {
          // @ts-ignore
          item.determinantId = eachGroup.id;
        } else {
         continue;
        }
      } else if (Array.isArray(eachGroup.items)) {
        item.items = this.cleanDeterminant(eachGroup.items);
        if (item.items.length === 0) {
          // @ts-ignore
          if (eachGroup.name && eachGroup.conditionType && eachGroup.determinantType && eachGroup.items.length > 0) {
            if (this.determinantMapById && Object.keys(this.determinantMapById).length > 0) {
              for (const entry of Object.entries(this.determinantMapById)) {
                // @ts-ignore
                if (eachGroup.name === entry[1]) {
                  item.determinantId = entry[0];
                  delete item.items;
                  break;
                }
              }
            } else {
              this._refreshGroups();
            }
          }
        } else if (item.items.length === 1 && item.items[0] && item.items[0].items && item.items[0].items.length === 1) {
          item.items[0].items[0].type = item.items[0].type;
          item.items = item.items[0].items;
        }
      } else {
        continue;
      }
      items.push(item);
    }
    return items;
  }

    public dropped(event: CdkDragDrop<LogicGroup[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            this.changeCopy = false;
            event.container.data.forEach((e, i) => {
              e.type = this.copy[i].type;
            });
            this.changeCopy = true;
        }
    }

    public droppedItem(event: CdkDragDrop<ILogicGeneric[]>, j) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            this.changeCopy = false;
            event.container.data.forEach((e, i) => {
              e.type = this.copy[j].items[i].type;
            });
            this.changeCopy = true;
        } else if (event.previousContainer.id.endsWith("-conditionsList")) {
            const item = event.previousContainer.data[event.previousIndex];
            if (item) {
              const copyItem = {type: item.type, determinantId: item.determinantId};
              event.container.data.splice(event.currentIndex, 0, copyItem);
            }
        } else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
        for (const item of event.container.data) {
          for (const key of Object.keys(item)) {
            if (key === "type" || key === "determinantId" ) {
              continue;
            }
            delete item[key];
          }
        }
        this.fireOnChangeEvent();
    }

  public ngOnChanges(changes: SimpleChanges): void {
    this.initGroups();
  }

  public initGroups() {
    if (this.jsonString?.jsonString) {
      this.jsonString = this.jsonString.jsonString;
    }
    setTimeout(() => {
      if (!this.jsonString || this.jsonString === "[]" || this.jsonString === undefined || this.jsonString === "undefined" || this.jsonString === "null") {
        this.groups = [new LogicGroup()];
        this.fireOnChangeEvent();
      } else {
        try {
          if (this.jsonString instanceof Array || typeof this.jsonString === "object") {
            this.groups = this.jsonString.jsonString ? this.jsonString.jsonString : this.jsonString;
          } else {
            this.groups = JSON.parse(this.jsonString);
          }
          if (!Array.isArray(this.groups)) {
            this.groups = [new LogicGroup()];
          }
          // @ts-ignore
          const cleanedGroups = this.cleanDeterminant(this.groups);
          if (cleanedGroups.length === 0) {
            cleanedGroups.push({
              type: LogicGroupType.OR,
              items: [],
            });
          }
          // @ts-ignore
          this.groups = cleanedGroups;
          const jsonString = JSON.stringify(this.groups);
          const isChanged = this.jsonString !== jsonString;
          if (isChanged) {
            this.fireOnChangeEvent();
          }
          this.jsonString = jsonString;
        } catch (e) {
          // eslint-disable-next-line
          this.error("Problem with parsing jsonstring", this.jsonString);
        }
      }
      this.copy = JSON.parse(JSON.stringify(this.groups));
    }, 10);
  }

  public addNewBlockAfter(group) {
    this.groups.splice(this.groups.indexOf(group) + 1, 0, new LogicGroup());
    this.fireOnChangeEvent();
  }

  public createConnectedTo(index) {
      const connectedTo = [];
      this.groups.forEach((group, i) => {
          if (i === index) { return; }
          connectedTo.push(this.prefix + "-conditionsSelected-" + i);
      });
      return connectedTo;
  }

  public fireOnChangeEvent() {
    this.setDeterminantCount();
    this.onChange.emit({
      groups: this.groups,
      jsonString: JSON.stringify(this.groups),
      determinantCount: this.determinantCount,
    });
  }

  public setDeterminantCount() {
    this.determinantCount = 0;
    for (const group of this.groups) {
      this.determinantCount += group.items.length;
    }
  }

  public removeGroup(j) {
    if (!this.readOnly) {
      this.groups.splice(j, 1);
      this.fireOnChangeEvent();
    }
  }

  public removeItemFromGroup(item, group) {
    group.items.splice(group.items.indexOf(item), 1);
    this.fireOnChangeEvent();
  }

  public groupAndOrTypeChanged(andOrType: string, groupIndex) {
    this.groups[groupIndex].type = this.getLogicType(andOrType);
    if (this.changeCopy) {
      this.copy = JSON.parse(JSON.stringify(this.groups));
    }
    this.fireOnChangeEvent();
  }

  public conditionAndOrTypeChanged(andOrType: string, groupIndex, conditionIndex) {
    this.groups[groupIndex].items[conditionIndex].type = this.getLogicType(andOrType);
    if (this.changeCopy) {
      this.copy = JSON.parse(JSON.stringify(this.groups));
    }
    this.fireOnChangeEvent();
  }

  public findDeterminantName(item: LogicCondition): string {
    return QueryBuilder.findDeterminantName(item, this.determinantMapById);
  }

  public static findDeterminantName(item: LogicCondition, determinantMapById: { [key: string]: string }) {
    let name = "";
    if (!determinantMapById || Object.keys(determinantMapById).length === 0) { return name; }
    item.items?.some((i) => {
      if (i.determinantId && determinantMapById[i.determinantId]) {
        name = determinantMapById[i.determinantId];
        return true;
      }
      if (i.id && determinantMapById[i.id]) {
        name = determinantMapById[i.id];
        return true;
      }
    });

    return name;
  }

  private getLogicType(andOrType: string) {
    return andOrType === "AND" ? LogicGroupType.AND : LogicGroupType.OR;
  }

}
